module.exports = __webpack_public_path__ + "static/piclife_img3-bf0631ee54d83ed02c3b43a641a15b0b.png";